import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import {
  AttachMoney,
  HouseSiding,
  LocalShipping,
  ShoppingBag,
} from "@mui/icons-material";
import { PriceDisplayBox } from "../../../inventory/components/PriceDisplayBox";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ProductDetail } from "../types";
import { getTotalCost } from "../utils";
import { Section } from "./Section";

type CostProps = {
  productDetail?: ProductDetail;
};
export const Cost = ({ productDetail }: CostProps) => {
  const { translate } = useTranslation("pages.product");
  return (
    <Section title={translate("cost")}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{translate("productPrice")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.price?.productCost}
                color="#bb2222"
                StartIcon={ShoppingBag}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("shippingCost")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.price?.shippingCost}
                color="#bb2222"
                StartIcon={LocalShipping}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("warehouseFee")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={productDetail?.price?.warehouseCost}
                color="#bb2222"
                StartIcon={HouseSiding}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("totalCost")}</TableCell>
            <TableCell>
              <PriceDisplayBox
                price={getTotalCost(productDetail?.price)}
                color="#bb2222"
                StartIcon={AttachMoney}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Section>
  );
};
